var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 16C3.98 16 2.68333 15.4767 1.61 14.43C0.536667 13.3767 0 12.0933 0 10.58C0 9.28 0.39 8.12 1.17 7.1C1.95667 6.08 2.98333 5.43 4.25 5.15C4.67 3.61667 5.50333 2.37667 6.75 1.43C8.00333 0.476667 9.42 0 11 0C12.9533 0 14.6067 0.68 15.96 2.04C17.32 3.39333 18 5.04667 18 7C19.1533 7.13333 20.1067 7.63333 20.86 8.5C21.62 9.35333 22 10.3533 22 11.5C22 12.7533 21.5633 13.8167 20.69 14.69C19.8167 15.5633 18.7533 16 17.5 16H12C11.4533 16 10.9833 15.8033 10.59 15.41C10.1967 15.0233 10 14.5533 10 14V8.85L8.4 10.4L7 9L11 5L15 9L13.6 10.4L12 8.85V14H17.5C18.2 14 18.79 13.7567 19.27 13.27C19.7567 12.79 20 12.2 20 11.5C20 10.8 19.7567 10.21 19.27 9.73C18.79 9.24333 18.2 9 17.5 9H16V7C16 5.62 15.5133 4.44 14.54 3.46C13.5667 2.48667 12.3867 2 11 2C9.62 2 8.44 2.48667 7.46 3.46C6.48667 4.44 6 5.62 6 7H5.5C4.53333 7 3.71 7.34333 3.03 8.03C2.34333 8.71 2 9.53333 2 10.5C2 11.4667 2.34333 12.3 3.03 13C3.71 13.6667 4.53333 14 5.5 14H8V16",
    fill: "#77777A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.3632a5dafa2ba6debbda0df901584406.svg";
export { ForwardRef as ReactComponent };